<script>
import { required, numeric } from "vuelidate/lib/validators";
import validationMessages from "@/components/validations";
import Merchandising from "@/services/Merchandising";
import Swal from "sweetalert2";
import id from "vue2-datepicker/locale/es/id";
import Multiselect from "vue-multiselect";

export default {
  props:['id','name','products'],
  components: { Multiselect, validationMessages },
  validations:{
    selectedProducts: { required },
  },
  data() {
    return {
      brand_name: "",
      showModal: false,
      submitted: false,
      isBusy: false,
      tryingToSubmit: false,
      showLoader: false,
      csrf_token: localStorage.getItem("csrf_token"),
      termID:'',
      termName:'',
      categoriesData:[],
      productData:[],
      modalProducts:[],
      selectedProducts:"",
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      selectedCategories:'',
      formatedCategories:[],
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "created_on",
      tableData: [],
      sortDesc: true,
      fields: [

        {
          key: "prod_id",
          label: "Product ID",
          sortable: true,
        },
        {
          key: "attr_name",
          label: "Attribute Name",
          sortable: true,
        },
        {
          key: "prod_name",
          label: "Product Name",
          sortable: true,
        },

        "action"
      ],


    };
  },
  computed:{
    filteredProducts(){
      if(!this.productData || this.productData.length === 0){
        return this.modalProducts
      }

      const linkedProducts = this.productData.map(prod =>
          prod.prod_id
      )

      return this.modalProducts.filter(product => !linkedProducts.includes(product.Art_ID))
    }
  },

  methods: {

    async submitForm() {
      this.tryingToSubmit = true;

      if (this.$v.$invalid) {
        this.submitted = true;
        this.tryingToSubmit = false;
        return;
      }
      const product_ids = this.selectedProducts.map(products => products.Art_ID);
      this.showLoader = true;
      const data = {
        term_id: this.termID,
        prod_id: product_ids,
      }
      try {
        const response = await Merchandising.addBulkProductsToTerm(data);
        if (response.success === false) {
          Swal.fire("Error", response.error || "Failed to link attribute. Please try again.", "error");
        } else {
          Swal.fire("Success", "Attribute successfully linked!", "success");
          this.closeModal();
          this.refreshData();
        }

      } catch (error) {
        // Catch any network or unexpected errors
        console.error("Failed to create attribute:", error);
        Swal.fire("Error", error.response?.data?.error || "Failed to create attribute. Please try again.", "error");
      } finally {
        this.tryingToSubmit = false;
        this.showLoader = false;
      }
    },

    async unlinkProduct(id) {
      Swal.fire({
        title: "Unlink Product?",
        text: "This Product will be unlinked from this Term!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Unlink!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await Merchandising.removeProductTerm(id);
            if (response.data) {
              Swal.fire("Success!", "Product is successfully unlinked !", "success");
              await this.getProductTerm();
            } else {
              let errorMessage = response.error ? response.error : 'Failed';
              if (typeof errorMessage === 'object') {
                errorMessage = errorMessage[0];
              }
              Swal.fire("Fail!", errorMessage, "warning");
            }
          } catch (error) {
            let errorMessage = error.response && error.response.data && error.response.data.error
                ? error.response.data.error
                : "An error occurred while unlinking product!";
            if (typeof errorMessage === 'object') {
              errorMessage = errorMessage[0];
            }
            Swal.fire("Error", errorMessage, "error");
          }
        }
      });
    },

    resetForm() {
      this.$v.$reset();
      this.selectedProducts= ""
      this.modalProducts= []
      this.selectedCategories = [];
      this.selectedProducts = [];
      this.tableData = [];
      this.totalRows = 0;
      this.currentPage = 1;
      this.perPage = 10;
      this.filter = null;
      this.filterOn = [];
      this.sortBy = "created_on";
      this.sortDesc = true;


    },
    customLabel(option) {
      return `${option.Art_Ime} - ${option.Art_ID}`;
    },


    closeModal() {
      this.resetForm();
      this.showModal = false;
    },

    async getProductTerm(){
      try {
        this.isBusy = true;
        // const response = await Merchandising.getProductTermsByTerm(this.termID);
        const response = await Merchandising.getProductTermsByTermMerch(this.termID);
        this.productData = response.data.data;
        this.tableData = this.productData;
        this.totalRows = this.productData.length;
        this.modalProducts = this.products;
      }catch (error){
        console.error(error);
        this.isBusy = false;
      }finally {
        this.isBusy = false;
      }
    },


    refreshData() {
      this.$emit("onRefresh");
    },
    async syncData(){
      this.termID = this.id;
      this.termName = this.name;
      await this.getProductTerm();
    }

  },


};
</script>

<template>
  <b-modal
      @hidden="resetForm"
      @shown="syncData"
      id="link_term"
      size="xl"
      v-model="showModal"
      title="Link Term to Products"
      title-class="font-18"
  >
    <form @submit.prevent="submitForm">
      <div class="row">

        <div class="row" >
          <div id="right_side" class="col-6">
            <h5>Term: {{termName}}</h5>
            <h5 style="margin-bottom:40px;">Total Linked Products: {{totalRows}}</h5>

            <b-form-group>
              <label class="typo__label" for="ajax">Products</label>
              <multiselect v-model="selectedProducts"
                           :custom-label="customLabel"
                           track-by="Art_ID"
                           placeholder="Type to search products"
                           :multiple="true"
                           :options="filteredProducts"
                           :searchable="true"
                           :loading="showLoader"
                           :internal-search="true"
                           :clear-on-select="false"
                           :close-on-select="false"
                           :options-limit="300"
                           :max-height="600"
                           :show-no-results="false"
                           :hide-selected="true"
                           :class="{ 'is-invalid': submitted && $v.selectedProducts.$error }">

                <template slot="tag" slot-scope="{ option, remove }">
                  <span class="custom__tag">
                      <span>{{ option.Art_Ime }} - {{option.Art_ID}}</span>
                      <span class="custom__remove" @click="remove(option)">✖</span>
                  </span>
                </template>
              </multiselect>
              <validationMessages v-if="submitted" :fieldName="'Selected Product'" :validationName="$v.selectedProducts"></validationMessages>

            </b-form-group>
          </div>
          <div id="left_side" class="col-6">
            <h5 class="text-center">Linked Products To Term {{termName}}</h5>
            <!-- Search -->
            <div class="col-sm-12 col-md-12">
              <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
              >
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
            <div class="table-responsive mb-0">
              <b-table
                  :items="tableData"
                  :busy="isBusy"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  show-empty
                  empty-text="No Data Found"
              >


                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(action)="data">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <a href="javascript:void(0);" @click="unlinkProduct(data.item.id)"  title="Unlink Product">
                        <i class="uil uil-link-broken font-size-18"></i>
                      </a>
                    </li>
                  </ul>
                </template>
              </b-table>
            </div>


            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="submitForm" :disabled="tryingToSubmit || showLoader">
        <b-spinner v-show="tryingToSubmit" small></b-spinner>Submit
      </b-button>
    </template>
  </b-modal>
</template>
